import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { ButtonDropdown } from '@grandvisionhq/common';
import { COLUMNED_DROPDOWN_PLACEHOLDER } from './constants.js';

const PLACEHOLDER = '---';
const DualColumnDropdown = ({ 'data-t': dataT , className , id , isDisabled , isInvalid , isRequired , label , onChange , options: options1 , selectedValue  })=>{
    const containsPlaceholder = Object.values(options1).includes(PLACEHOLDER);
    const containsZero = Object.values(options1).some((value)=>Number(value) === 0
    );
    const optionsArray = Object.entries(options1).map(([key, value])=>({
            label: key,
            value
        })
    );
    const negativeOptions = optionsArray.filter((power)=>Number(power.value) < 0
    ).sort((a, b)=>Number(a.label) - Number(b.label)
    ).reverse();
    const positiveOptions = optionsArray.filter((power)=>Number(power.value) > 0
    ).sort((a, b)=>Number(a.label) - Number(b.label)
    );
    const maxLength = Math.max(negativeOptions.length, positiveOptions.length);
    const rows = Array.from({
        length: maxLength
    }, (_, index)=>{
        return [
            swcHelpers.objectSpread({}, negativeOptions[index]),
            swcHelpers.objectSpread({}, positiveOptions[index])
        ];
    });
    return /*#__PURE__*/ React.createElement(ButtonDropdown, {
        "aria-label": label,
        className: classnames(className, 'dual-columned-dropdown'),
        "data-t": dataT,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        isRequired: isRequired,
        onChange: onChange,
        value: selectedValue,
        cols: 2,
        orientation: "both",
        itemSizes: optionsArray.map((_, index)=>{
            if (containsZero && index === 0) {
                return {
                    width: 2,
                    height: 1
                };
            }
            return {
                width: 1,
                height: 1
            };
        })
    }, /*#__PURE__*/ React.createElement(ButtonDropdown.Select, {
        placeholder: COLUMNED_DROPDOWN_PLACEHOLDER,
        className: "dual-columned-dropdown__select",
        id: id
    }), /*#__PURE__*/ React.createElement(ButtonDropdown.Content, {
        type: "select",
        className: "dual-columned-dropdown__content"
    }, containsPlaceholder ? /*#__PURE__*/ React.createElement(ButtonDropdown.GridRow, {
        className: classnames('dual-columned-dropdown__row', 'dual-columned-dropdown__row--full-width')
    }, /*#__PURE__*/ React.createElement(ButtonDropdown.GridCell, {
        className: "dual-columned-dropdown__cell"
    }, /*#__PURE__*/ React.createElement(ButtonDropdown.Option, {
        value: PLACEHOLDER,
        className: "dual-columned-dropdown__option"
    }, PLACEHOLDER))) : null, containsZero ? /*#__PURE__*/ React.createElement(ButtonDropdown.GridRow, {
        className: classnames('dual-columned-dropdown__row', 'dual-columned-dropdown__row--full-width')
    }, /*#__PURE__*/ React.createElement(ButtonDropdown.GridCell, {
        className: "dual-columned-dropdown__cell"
    }, /*#__PURE__*/ React.createElement(ButtonDropdown.Option, {
        value: 0,
        className: "dual-columned-dropdown__option"
    }, "0.00"))) : null, rows.map((options)=>{
        var ref, ref1;
         return React.createElement(ButtonDropdown.GridRow, {
            key: `${options === null || options === void 0 ? void 0 : (ref = options[0]) === null || ref === void 0 ? void 0 : ref.value}-${options === null || options === void 0 ? void 0 : (ref1 = options[1]) === null || ref1 === void 0 ? void 0 : ref1.value}`,
            className: "dual-columned-dropdown__row"
        }, options.map((option)=>{
            if (!option) return /*#__PURE__*/ React.createElement(ButtonDropdown.GridCell, {
                key: "empty-cell",
                className: "dual-columned-dropdown__cell"
            }, /*#__PURE__*/ React.createElement(ButtonDropdown.EmptyOption, {
                className: "dual-columned-dropdown__option"
            }));
            return option.value ? /*#__PURE__*/ React.createElement(ButtonDropdown.GridCell, {
                key: option.value,
                className: "dual-columned-dropdown__cell"
            }, /*#__PURE__*/ React.createElement(ButtonDropdown.Option, {
                value: option.value,
                className: "dual-columned-dropdown__option"
            }, option.label)) : null;
        }));
    })));
};

export { DualColumnDropdown };
//# sourceMappingURL=DualColumnDropdown.js.map
